/**
 * Centralized API Configuration
 * Single source of truth for all API endpoints
 */

// Base API URL - can be overridden by environment variable
const API_BASE = process.env.REACT_APP_API_BASE || 'https://trysnowball.co.uk';

// API endpoints configuration
export const API_CONFIG = {
  BASE: API_BASE,
  AUTH: {
    BASE: `${API_BASE}/auth`,
    HEALTH: `${API_BASE}/auth/health`,
    REQUEST_LINK: `${API_BASE}/auth/request-link`,
    VERIFY: `${API_BASE}/auth/verify`,
    ME: `${API_BASE}/auth/me`,
    REFRESH: `${API_BASE}/auth/refresh`,
    LOGOUT: `${API_BASE}/auth/logout`,
  },
  AI: {
    BASE: `${API_BASE}/ai`,
    HEALTH: `${API_BASE}/ai/health`,
    COACH: `${API_BASE}/ai/coach`,
  }
};

// Environment info for debugging
export const ENV_INFO = {
  API_BASE: API_BASE,
  NODE_ENV: process.env.NODE_ENV,
  BUILD_COMMIT: process.env.REACT_APP_COMMIT_HASH,
  BUILD_DATE: process.env.REACT_APP_BUILD_DATE,
};

// Debug helper for console inspection
if (process.env.NODE_ENV === 'development') {
  window.__TS_API_CONFIG__ = API_CONFIG;
  window.__TS_ENV_INFO__ = ENV_INFO;
  console.log('🔧 API Config loaded:', API_CONFIG);
}